import type React from "react";
import { Box, Typography, Avatar } from "@mui/material";
import { motion } from "framer-motion";

interface ContactCardProps {
  name: string;
  phone: string;
  email: string;
  avatarUrl?: string;
}

const MotionBox = motion(Box);

const ContactCard: React.FC<ContactCardProps> = ({
  name,
  phone,
  email,
  avatarUrl,
}) => {
  return (
    <MotionBox
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
      sx={{
        display: "flex",
        alignItems: "center",
        p: 2,
        borderRadius: 1,
        border: "1px solid",
        borderColor: "divider",
        mb: 2,
      }}
    >
      <Avatar
        src={avatarUrl}
        alt={name}
        sx={{ width: 56, height: 56, mr: 2 }}
      />
      <Box>
        <Typography variant="subtitle1" fontWeight="medium">
          {name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {phone}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {email}
        </Typography>
      </Box>
    </MotionBox>
  );
};

export default ContactCard;
